import { ChangeEvent, FC, useState } from 'react';
import { Button, Dialog, FormLabel, Input, Typography, Wrapper } from '@screentone/core';

import styles from './CloneLayoutModal.module.scss';

interface CloneLayoutModalProps {
  pageTitle: string;
  onDismiss: () => void;
  onConfirm: (pageTitle: string) => void;
  isReadOnly?: boolean;
}

export const CloneLayoutModal: FC<CloneLayoutModalProps> = ({
  pageTitle: initialPageTitle,
  onDismiss,
  onConfirm,
  isReadOnly = false
}) => {
  const [pageTitle, setPageTitle] = useState(`Copy of ${initialPageTitle}`);

  const trimmedTitle = pageTitle.trim();
  const isValid = trimmedTitle.length > 0;

  const handleClone = () => {
    onConfirm(trimmedTitle);
    onDismiss();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPageTitle(e.target.value);
  };

  return (
    <Dialog status="open" onDismiss={onDismiss} focusTrap={false}>
      <Dialog.Title>Clone Page</Dialog.Title>
      <Dialog.Content>
        <Wrapper padding={{ bottom: 'md' }}>
          <Typography className={styles.description}>
            Add a page title to your cloned page or use the default label provided here.
          </Typography>
        </Wrapper>
        <FormLabel label="New Page Title" labelPosition="top" fullWidth className={styles.input}>
          <Input
            name="clone-layout-title"
            value={pageTitle}
            onChange={handleChange}
            data-testid="clone-layout-title-input"
            error={!isValid}
            disabled={isReadOnly}
          />
        </FormLabel>
        <Dialog.Actions className={styles.buttons}>
          <Button secondary onClick={onDismiss} data-testid="clone-layout-cancel">
            Cancel
          </Button>
          <Button primary onClick={handleClone} data-testid="clone-layout-confirm" disabled={!isValid || isReadOnly}>
            Clone
          </Button>
        </Dialog.Actions>
      </Dialog.Content>
    </Dialog>
  );
};
